module.exports = __webpack_public_path__ + "static/Command_And_Control_Systems-c73114949afab26e205d39a2ebb59ccd.jpeg";